import { getBuildNumber, getVersionNumber } from "../utils/environment";

export const getBuildVersion = (): string =>
  `${getVersionNumber()}.${getBuildNumber()}`;

export const getDefaultHeaders = (
  token: string | undefined | null
): Record<string, string> => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
  "X-Build-Version": getBuildVersion()
});

/**
 * Headers for JSON-returning collins-api endpoints. collins-api renders an
 * HTML error page (401/403) unless JSON is explicitly accepted, which then
 * breaks response.json() error handling downstream.
 */
export const collinsApiHeaders = (
  token: string | undefined | null
): Record<string, string> => ({
  ...getDefaultHeaders(token),
  Accept: "application/json"
});
